<script lang="ts">
    import {MenuItem} from '@rgossiaux/svelte-headlessui';

    export let href: string;
    export let isDisabled = false;
    export let showWhen = true;
</script>

{#if showWhen}
    <MenuItem as="li" disabled="{isDisabled}">
        <a href={href}>
            <slot></slot>
        </a>
    </MenuItem>
{/if}